(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStory(card) {
    var scenes = Array.prototype.slice.call(card.querySelectorAll('[data-bundle-scene]'));
    var steps = Array.prototype.slice.call(card.querySelectorAll('[data-bundle-step]'));
    var videos = Array.prototype.slice.call(card.querySelectorAll('[data-bundle-video]'));
    var progress = card.querySelector('[data-bundle-progress]');
    var motionButton = card.querySelector('[data-bundle-motion]');
    var motionIcon = card.querySelector('[data-bundle-motion-icon]');
    var motionLabel = card.querySelector('[data-bundle-motion-label]');
    var index = 0;
    var startedAt = 0;
    var elapsedBeforePause = 0;
    var animationFrame = 0;
    var timer = 0;
    var userPaused = false;
    var inView = true;

    if (!scenes.length) return;

    videos.forEach(function (video) {
      var scene = video.closest('[data-bundle-scene]');
      video.addEventListener('error', function () {
        if (scene) scene.classList.add('has-video-error');
      });
      video.addEventListener('canplay', function () {
        if (scene) scene.classList.remove('has-video-error');
      });
    });

    function durationFor(scene) {
      return Number(scene.getAttribute('data-duration')) || 10000;
    }

    function pauseVideos() {
      videos.forEach(function (video) {
        try { video.pause(); } catch (error) {}
      });
    }

    function playActiveVideo() {
      var video = scenes[index].querySelector('[data-bundle-video]');
      if (!video || userPaused || !inView || document.hidden) return;
      try {
        video.currentTime = Math.min(elapsedBeforePause / 1000, Math.max((video.duration || 10) - 0.1, 0));
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      } catch (error) {}
    }

    function updateMotionControl() {
      if (!motionButton) return;
      var paused = userPaused;
      motionButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
      motionButton.setAttribute('aria-label', paused ? 'Play bundle product story' : 'Pause bundle product story');
      if (motionIcon) motionIcon.textContent = paused ? '▶' : 'Ⅱ';
      if (motionLabel) motionLabel.textContent = paused ? 'Play' : 'Pause';
    }

    function showScene(nextIndex, preserveElapsed) {
      window.clearTimeout(timer);
      window.cancelAnimationFrame(animationFrame);
      pauseVideos();
      index = (nextIndex + scenes.length) % scenes.length;
      if (!preserveElapsed) elapsedBeforePause = 0;

      scenes.forEach(function (scene, sceneIndex) {
        var active = sceneIndex === index;
        scene.classList.toggle('is-active', active);
        scene.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      steps.forEach(function (step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === index);
      });

      if (progress) progress.style.width = '0%';
      if (!userPaused && inView && !document.hidden) start();
    }

    function tick(now) {
      var elapsed = elapsedBeforePause + (now - startedAt);
      var duration = durationFor(scenes[index]);
      if (progress) progress.style.width = Math.min(100, (elapsed / duration) * 100) + '%';
      if (!userPaused && inView && !document.hidden) {
        animationFrame = window.requestAnimationFrame(tick);
      }
    }

    function start() {
      if (reduceMotion || userPaused || !inView || document.hidden) return;
      window.clearTimeout(timer);
      window.cancelAnimationFrame(animationFrame);
      startedAt = performance.now();
      playActiveVideo();
      animationFrame = window.requestAnimationFrame(tick);
      timer = window.setTimeout(function () {
        elapsedBeforePause = 0;
        showScene(index + 1, false);
      }, Math.max(60, durationFor(scenes[index]) - elapsedBeforePause));
    }

    function pause() {
      window.clearTimeout(timer);
      window.cancelAnimationFrame(animationFrame);
      if (startedAt) {
        elapsedBeforePause = Math.min(
          durationFor(scenes[index]),
          elapsedBeforePause + (performance.now() - startedAt)
        );
      }
      startedAt = 0;
      pauseVideos();
    }

    if (reduceMotion) {
      index = scenes.length - 1;
      showScene(index, false);
      return;
    }

    if (motionButton) {
      motionButton.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) pause();
        else start();
        updateMotionControl();
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting && entry.intersectionRatio > 0.18;
          if (inView) start();
          else pause();
        });
      }, { threshold: [0, .18, .45] });
      observer.observe(card);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else start();
    });

    updateMotionControl();
    showScene(0, false);
  }

  function initCountdown(card) {
    var wrapper = card.querySelector('[data-bundle-countdown]');
    var value = card.querySelector('[data-bundle-countdown-value]');
    var buyLink = card.querySelector('[data-bundle-story-buy]');
    var endValue = card.getAttribute('data-offer-ends');
    if (!wrapper || !value || !endValue) return;

    var endsAt = new Date(endValue).getTime();
    if (!Number.isFinite(endsAt)) return;

    function expireOffer() {
      wrapper.classList.add('is-expired');
      value.textContent = 'Offer ended';
      if (!buyLink) return;
      buyLink.classList.add('is-disabled');
      buyLink.setAttribute('aria-disabled', 'true');
      buyLink.removeAttribute('href');
      buyLink.textContent = 'Offer ended';
    }

    function render() {
      var remaining = endsAt - Date.now();
      if (remaining <= 0) {
        expireOffer();
        return false;
      }
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      value.textContent =
        String(days).padStart(2, '0') + 'd : ' +
        String(hours).padStart(2, '0') + 'h : ' +
        String(minutes).padStart(2, '0') + 'm : ' +
        String(seconds).padStart(2, '0') + 's';
      return true;
    }

    if (render()) {
      var interval = window.setInterval(function () {
        if (!render()) window.clearInterval(interval);
      }, 1000);
    }
  }

  function initCompleteStory(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-panel]'));
    var detailVideos = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-detail-video]'));
    var dialog = root.querySelector('[data-bundle-dialog]');
    var dialogCard = root.querySelector('.bundle-asset-dialog-card');
    var dialogImage = root.querySelector('[data-bundle-dialog-image]');
    var dialogTitle = root.querySelector('[data-bundle-dialog-title]');
    var dialogCloseButtons = dialog
      ? Array.prototype.slice.call(dialog.querySelectorAll('[data-bundle-dialog-close]'))
      : [];
    var assetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-asset]'));
    var activePanelKey = tabs.length ? tabs[0].getAttribute('data-bundle-tab') : '';
    var storyInView = true;
    var lastDialogTrigger = null;

    function pauseDetailVideos() {
      detailVideos.forEach(function (video) {
        try { video.pause(); } catch (error) {}
      });
    }

    function playActiveDetailVideo() {
      if (reduceMotion || !storyInView || document.hidden || !activePanelKey) return;
      var panel = root.querySelector('[data-bundle-panel="' + activePanelKey + '"]');
      var video = panel && panel.querySelector('[data-bundle-detail-video]');
      if (!video) return;
      try {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      } catch (error) {}
    }

    function activatePanel(key, focusTab) {
      activePanelKey = key;
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-bundle-tab') === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-bundle-panel') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      pauseDetailVideos();
      playActiveDetailVideo();
    }

    tabs.forEach(function (tab, tabIndex) {
      tab.addEventListener('click', function () {
        activatePanel(tab.getAttribute('data-bundle-tab'), false);
      });
      tab.addEventListener('keydown', function (event) {
        var nextIndex = tabIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (tabIndex + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        activatePanel(tabs[nextIndex].getAttribute('data-bundle-tab'), true);
      });
    });

    detailVideos.forEach(function (video) {
      var media = video.closest('.bundle-product-media');
      video.addEventListener('error', function () {
        if (media) media.classList.add('has-video-error');
      });
      video.addEventListener('canplay', function () {
        if (media) media.classList.remove('has-video-error');
      });
    });

    function closeDialog() {
      if (!dialog || dialog.hidden) return;
      dialog.hidden = true;
      document.body.classList.remove('bundle-dialog-open');
      if (dialogImage) {
        dialogImage.removeAttribute('src');
        dialogImage.alt = '';
      }
      if (lastDialogTrigger) lastDialogTrigger.focus();
      lastDialogTrigger = null;
      playActiveDetailVideo();
    }

    function openDialog(button) {
      if (!dialog || !dialogImage) return;
      var src = button.getAttribute('data-bundle-asset');
      if (!src) return;
      lastDialogTrigger = button;
      pauseDetailVideos();
      dialogImage.src = src;
      dialogImage.alt = button.getAttribute('data-bundle-asset-alt') || 'Product image';
      if (dialogTitle) dialogTitle.textContent = dialogImage.alt;
      dialog.hidden = false;
      document.body.classList.add('bundle-dialog-open');
      if (dialogCard) dialogCard.focus();
    }

    assetButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openDialog(button);
      });
    });

    dialogCloseButtons.forEach(function (button) {
      button.addEventListener('click', closeDialog);
    });

    if (dialog) {
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(
          dialog.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) {
          return !element.hidden && element.offsetParent !== null;
        });
        if (!focusable.length) {
          event.preventDefault();
          if (dialogCard) dialogCard.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          storyInView = entry.isIntersecting && entry.intersectionRatio > 0.08;
          if (storyInView) playActiveDetailVideo();
          else pauseDetailVideos();
        });
      }, { threshold: [0, .08, .35] });
      observer.observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseDetailVideos();
      else playActiveDetailVideo();
    });

    activatePanel(activePanelKey, false);
  }

  function init() {
    document.querySelectorAll('[data-bundle-story]').forEach(function (card) {
      initStory(card);
      initCountdown(card);
    });
    document.querySelectorAll('[data-bundle-complete]').forEach(initCompleteStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
